export const TRIGGER_UPDATE_RIGHT_SIDEBAR = 'sidebar/TRIGGER_UPDATE_RIGHT_SIDEBAR';
export const UPDATE_RIGHT_SIDEBAR = 'sidebar/UPDATE_RIGHT_SIDEBAR';
export const SET_HIGHLIGHTED_BUTTON = 'sidebar/SET_HIGHLIGHTED_BUTTON';

export function triggerUpdateRightSidebar(payload = {}) {
  return {
    type: TRIGGER_UPDATE_RIGHT_SIDEBAR,
    payload,
  };
}

export function updateRightSidebar(payload = {}) {
  return {
    type: UPDATE_RIGHT_SIDEBAR,
    payload
  };
}

export function setHighlightedSidebarButton(payload = '') {
  return {
    type: SET_HIGHLIGHTED_BUTTON,
    payload
  };
}
